import { useCallback, useEffect, useState } from 'react';

import { twMerge } from 'tailwind-merge';

import type { ContainerProps, RawInputProps } from '@/_components';
import { DateInput } from '@/_components';
import { useBoolean } from '@/_shared';

export function CellDateInput({
  className,
  onValueChange,
  containerProps,
  ...props
}: Omit<RawInputProps, 'value'> & {
  value: string | null;
  containerProps?: ContainerProps;
  onValueChange: (v: string | null) => boolean;
}) {
  const [hasIssue, setHasIssue] = useBoolean(false);
  const [value, setValue] = useState<string | null>(props.value ?? null);

  // If the initialValue is changed external, sync it up with our state
  useEffect(() => {
    setValue(props.value ?? null);
  }, [props.value]);

  const handleChange = useCallback(
    (date: string | null) => {
      setHasIssue.set(!onValueChange(date as string | null));
    },
    [onValueChange, setHasIssue]
  );

  return (
    <DateInput
      value={value as string}
      onValueChange={handleChange}
      className={twMerge(
        'border-b-2 pt-0.5 pb-0.5 text-center text-xs',
        hasIssue && 'border-error dark:border-error',
        className
      )}
      labelProps={{ className: '' }}
      containerProps={{ ...(containerProps || { className: 'h-6' }) }}
    />
  );
}
